import apiClient from '../lib/apiClient';

export const getMyWalletApi = () =>
  apiClient('/wallet/my-wallet');

export const initiateTopUpApi = (payload) =>
  apiClient('/wallet/topup', { method: 'POST', body: payload });

export const checkTopUpStatusApi = (referenceId) =>
  apiClient(`/wallet/topup/status/${referenceId}`);

export const getPricingApi = () =>
  apiClient('/wallet/pricing');

export const getServicePricingApi = (service_type) =>
  apiClient(`/wallet/pricing/${service_type}`);
